import { create } from 'zustand';

import {
  ChatDtoStatus,
  ChatsControllerGetMineByQueryParamsStatus,
  ChatsControllerGetMineByQueryParamsStatus2,
  ChatsControllerGetQueryResponse,
  UsersControllerGetMeQueryResponse,
} from '~/shared/api/generated';

type Status =
  | ChatsControllerGetMineByQueryParamsStatus[]
  | ChatsControllerGetMineByQueryParamsStatus2
  | undefined;

type SupportChatStore = {
  chats: ChatsControllerGetQueryResponse[];
  activeChatId: string;
  activeStatus: Status;
  setChats: (chat: ChatsControllerGetQueryResponse) => void;
  loadChats: (chats: ChatsControllerGetQueryResponse[]) => void;
  changeChatStatus: (chatId: string, status: ChatDtoStatus) => void;
  assignAdmin: (
    admin: UsersControllerGetMeQueryResponse,
    chatId: string,
  ) => void;
  setActiveChat: (id: string) => void;
  getActiveChat: (activeChatId: string) => ChatsControllerGetQueryResponse;
  setActiveStatus: (status: Status) => void;
  getChatsByStatus: (status: Status) => ChatsControllerGetQueryResponse[];
};

export const useSupportChats = create<SupportChatStore>((set, get) => ({
  chats: [],
  activeChatId: '0',
  activeStatus: 'open',
  setChats: (chat) =>
    set((state) => ({
      ...state,
      chats: [...state.chats, chat],
    })),
  changeChatStatus: (chatId, status) =>
    set((state) => ({
      ...state,
      chats: state.chats.map((chat) =>
        chat.id === chatId ? { ...chat, status } : chat,
      ),
    })),
  assignAdmin: (admin, chatId) =>
    set((state) => ({
      ...state,
      chats: state.chats.map((chat) =>
        chat.id === chatId ? { ...chat, admin } : chat,
      ),
    })),
  loadChats: (chats) =>
    set((state) => ({
      ...state,
      chats,
    })),
  setActiveChat: (id) =>
    set((state) => ({
      ...state,
      activeChatId: id,
    })),
  getActiveChat: (activeChatId) => {
    const { chats } = get();
    return chats.find((chat) => chat.id === activeChatId);
  },
  setActiveStatus: (status) => {
    set((state) => ({
      ...state,
      activeStatus: status,
    }));
  },
  getChatsByStatus: (status) => {
    const { chats } = get();
    const result = chats.filter((chat) => chat.status === status);
    // if (result.length > 0) {
    return result;
    // }
    // return chats;
  },
}));
